import { AuthUserPerfilId, IAuthUserPerfil } from './IAuthUserPerfil';

export default ((): IAuthUserPerfil => {
  return {
    id: AuthUserPerfilId.Associado,
    nome: 'Associado',
    associadoRoute: {
      assembleias: {
        pre: {
          ver: true,
          videos: {
            ver: true,
            participar: false,
          },
          documentos: {
            ver: true,
            participar: false,
          },
          duvidasSugestoes: {
            ver: true,
            participar: true,
          },
        },
        live: {
          ver: true,
          video: {
            ver: true,
            participar: false,
          },
          documentos: {
            ver: true,
            participar: false,
          },
          duvidasSugestoes: {
            ver: true,
            participar: true,
          },
        },
        pautas: {
          ver: true,
          participar: true,
        },
      },
    },
    assessorRoute: {
      assembleias: {
        ver: false,
        excluir: false,
        alterarSituacao: false,
        documentos: {
          ver: false,
          editar: false,
        },
        participantes: {
          verTotal: false,
          confirmar: false,
        },
        pautas: {
          ver: false,
          alterarSituacao: false,
          incluirVotoManual: false,
          editar: false,
          deletar: false,
          anexos: {
            ver: false,
          },
        },
        cadastroPauta: {
          cadastrar: false,
        },
        relatorio: {
          votacao: false,
          evento: false,
        },
        videos: {
          editar: false,
        },
        adicionarConvidado: false,
      },
      duvidasSugestoes: {
        ver: false,
        responder: false,
        alterarSituacao: false,
        incluirMensagem: false,
        mensagemAssessor: false,
        relatorio: false,
      },
      parametros: {
        ver: false,
        editar: false,
      },
      quorum: {
        ver: false,
        alterarRepresentante: false,
      },
      logins: {
        ver: false,
      },
      cadastros: {
        ver: false,
      },
      notificacoes: {
        ver: false,
      },
    },
  };
})();
